import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Main from 'layouts/Main';
import Container from 'components/Container';
import { Headline, Form } from './components';
import Alert from '@mui/material/Alert';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';

import useSendEmail from 'Hooks/useSendContactUsEmail';
import { useNotify } from 'components/NotificationProvider';

const ContactUs = () => {
  const theme = useTheme();
  const { sendEmail, isLoading, isSuccess, error } = useSendEmail();
  const { notify, notifyError } = useNotify();
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    message: '',
    captchaToken: '',
    website: '',
  });

  useEffect(() => {
    if (isSuccess) {
      setOpen(true);
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        company: '',
        message: '',
        captchaToken: '',
        website: '',
      });
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isSuccess === false && error) {
      notifyError(error);
    }
  }, [isSuccess, error, notifyError]);

  const handleRequestQuote = async () => {
    const formFilled = isFormFilled();
    if (formFilled) {
      await sendEmail(formData);
    } else {
      notify(
        'Please fill out all required fields before requesting a quote.',
        'warning',
      );
    }
  };

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  const isFormFilled = () => {
    return (
      formData.firstName.trim() !== '' &&
      formData.lastName.trim() !== '' &&
      formData.email.trim() !== '' &&
      formData.captchaToken.trim() !== '' &&
      formData.website.trim() === ''
    );
  };
  return (
    <Main>
      <Box>
        <Box
          sx={{
            backgroundColor: theme.palette.alternate.main,
            backgroundImage: `linear-gradient(120deg, ${theme.palette.background.paper} 0%, ${theme.palette.alternate.main} 100%)`,
            marginTop: -13,
            paddingTop: 13,
          }}
        >
          <Container>
            <Headline />
          </Container>
        </Box>
        <Container maxWidth={800}>
          <Form
            formData={formData}
            setFormData={setFormData}
            handleSubmit={handleRequestQuote}
            disabled={isLoading}
          />
        </Container>
        {/* Notyfikacja */}
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert
            onClose={handleClose}
            severity="success"
            sx={{ width: '100%', marginTop: '60px' }}
          >
            Request has been sent!
          </Alert>
        </Snackbar>
      </Box>
    </Main>
  );
};

export default ContactUs;
